<template>
  <div>
    <div class="title-div">密码重置</div>
    <div class="form-div">
      <el-form ref="form" :model="form" label-width="80px" label-position="top" :rules="rules" hide-required-asterisk>
        <el-form-item label="联系电话：" prop="accountNumber">
          <el-input v-model="form.accountNumber" placeholder="请输入您的手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="sms">
          <el-input v-model="form.sms" placeholder="请输入手机验证码" maxlength="6">
            <el-button slot="append" :disabled="isSmsSend" @click="getVeriCode" class="verification-code-button">{{this.sendBtnText}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <el-input type="password" v-model="form.password" autocomplete="off" placeholder="8-20位英文和数字" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码：" prop="passwordCfm">
          <el-input type="password" v-model="form.passwordCfm" autocomplete="off" placeholder="8-20位英文和数字" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-button" @click="onSubmit">提交</el-button>
          <span style="color: #999999">提示：密码必须包含字母和数字</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getVerificationCode, resetPwd } from '../../api/login'
  export default {

    name: 'PasswordReset',
    data() {

      var validatorPhone = function (rule, value, callback) {
        let rules = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
        if (!rules.test(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }

      //密码验证
      var validatePassward = (rule, value, callback) => {
        const regp = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/
        if (value === '') {
          callback(new Error('请输入密码'))
        } else if (value.length < 8 || (value.length > 20 || !regp.test(this.form.password))) {
          callback(new Error('密码格式错误!'))
        } else {
          callback()
        }
      }

      //确认密码验证
      var validatePassward2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }


      return {
        form: {
          accountNumber: '', // 联系电话
          pass: '', // 密码
          sms: '', // 验证码
          password: '' // 新密码
        },
        isSmsSend: false, // 是否已经发送了验证码
        timer: null,
        sendBtnText: '获取验证码', // 获取验证码按钮文本
        counter: 60,// 倒计时秒数

        rules: {
          accountNumber: [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
            { required: true, validator: validatorPhone, trigger: 'blur' },
          ],
          sms: [
            { required: true, message: '请输入手机验证码', trigger: 'blur' },
            { min: 6, max: 6, message: '验证码长度为6位', trigger: 'blur'},
          ],
          password: [
            { required: true, validator: validatePassward, trigger: 'blur' },
          ],
          passwordCfm: [
            { required: true, validator: validatePassward2, trigger: 'blur' },
          ]
        } // 校验规则
      }
    },
    methods: {
      // 提交
      onSubmit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {

            const params = {
              mobile: this.form.accountNumber,
              code: this.form.sms,
              password: this.form.password
            }

            resetPwd(params).then(res => {
              if (res.data.success) {
                this.$message.success('重置密码成功')
                // 返回登录页面
                this.$router.push({ path: '/pcLogin' })
              } else {
                this.$message.error(res.data.message)
              }
            }).catch((err) => {
              console.log(err)
            })

          } else {

            return false
          }
        })
      },

      //获取验证码
      getVeriCode () {
        this.$refs.form.validateField('accountNumber', errMsg => {
          if (errMsg) {
            this.$message.error('请输入正确格式的手机号！')
          } else {

            const tall = encodeURI(this.form.accountNumber)
            const params = {
              mobile: tall,
              type: 'reset'
            }


            getVerificationCode(params).then(res => {
              if (res.data.success) {
                this.$message.success('验证码已发送！')
              } else {
                this.$message.error(res.data.message)
                // 返回登录页面
                this.$router.push({ path: '/pcLogin' })
              }
            }).catch((err) => {
              console.log(err)
            })

            // 将按钮禁用，防止再次点击
            this.isSmsSend = true
            // 开始倒计时，60s之后才能再次点击
            this.countDown()
          }
        })
      },

      // 倒计时
      countDown () {
        // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
        this.timer = setInterval(() => {
          // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
          this.sendBtnText = `${this.counter}s`
          this.counter--
          if (this.counter < 0) {
            // 当计时小于零时，取消该计时器
            clearInterval(this.timer)
            this.reset()
          }
        }, 1000)
      },

      // 重置倒计时
      reset () {
        // 重置按钮可用
        this.isSmsSend = false
        // 重置文本内容
        this.sendBtnText = '获取验证码'
        if (this.timer) {
          // 存在计时器对象，则清除
          clearInterval(this.timer)
          // 重置秒数，防止下次混乱
          this.counter = 60
          // 计时器对象重置为空
          this.timer = null
        }
      }
    },

  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .form-div {
    padding: 47px 40% 57px 40%;
  }

  .submit-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .verification-code-button {
    font-size: 18px !important;
    font-family: MicrosoftYaHei;
    color: #FFFFFF !important;
    height: 40px;
    padding: 0 20px;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  /deep/.el-form--label-top .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .el-input-group__append button.el-button {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }
</style>
